module.exports = __webpack_public_path__ + "img/battle.net.e94babcd.png";